export default __webpack_public_path__ + "static/media/SecPlusCert.3fb529da.png";